export default {
  projectTypes: {
    nature_based: "Natureza / Uso da Terra (AFOLU)",
    energy_industry: "Energia e indústria",
    waste_methane: "Resíduos e metano",
    carbon_removal: "Remoção de carbono e novas tecnologias",
    community_development: "Comunidade e desenvolvimento",
  },
  certifiers: {
    verra: "Verra",
    goldstandard: "Gold Standard",
    gcc: "GCC",
    tero: "Tero",
    planvivo: "Plan Vivo",
    arttrees: "ART TREES",
    socialcarbon: "Social Carbon",
    equitableearth: "Equitable Earth",
    isometric: "Isometric",
    puro: "Puro.earth",
  },
  methodologies: {
    afforestation_reforestation_ghg_emissions_reductions_sequestration_methodology:
      "Metodologia de redução de emissões de GEE e sequestro por florestamento e reflorestamento",
    agroforestry: "Agrofloresta",
    ar_acm0003_afforestation_and_reforestation_of_lands:
      "AR-ACM0003 - Florestamento e reflorestamento de terras",
    art_trees: "ART-TREES",
    art_trees_removals: "ART-TREES - remoções",
    biochar: "Biochar",
    biochar_production_and_storage: "Produção e armazenamento de biochar",
    biogenic_carbon_capture_and_storage:
      "Captura e armazenamento de carbono biogênico",
    biomass_fermentation_with_carbon_capture_and_geologic_storage:
      "Fermentação de biomassa com captura e armazenamento geológico de carbono",
    carbon_mineralisation_using_reactive_mineral_waste:
      "Mineralização de carbono usando resíduos minerais reativos",
    carbonated_materials: "Materiais carbonatados",
    direct_air_capture_and_ocean_storage:
      "Captura direta do ar e armazenamento oceânico",
    direct_ocean_capture_and_storage:
      "Captura direta do oceano e armazenamento",
    electrolytic_seawater_mineralization:
      "Mineralização eletrolítica da água do mar",
    emission_reduction_by_shore_side_or_off_shore_electricity_supply_system:
      "Redução de emissões por sistema de fornecimento elétrico em terra ou offshore",
    emission_reductions_from_safe_drinking_water_supply:
      "Reduções de emissões por fornecimento de água potável segura",
    enhanced_rock_weathering: "Intemperismo acelerado de rochas",
    gccm001_methodology_for_renewable_energy_generation_projects_supplying_electricity_to_grid_or_captive_consumers:
      "GCCM001 - Metodologia para projetos de geração renovável que fornecem eletricidade à rede ou a consumidores cativos",
    gccm002_methodology_for_energy_saving_in_pumping_systems:
      "GCCM002 - Metodologia para economia de energia em sistemas de bombeamento",
    gccm003_methodology_for_energy_generation_from_animal_manure_and_waste_management_projects:
      "GCCM003 - Metodologia para geração de energia a partir de dejetos animais e gestão de resíduos",
    gccm004_methodology_for_water_grid_connected_renewable_energy_based_desalination_plant:
      "GCCM004 - Metodologia para dessalinização renovável conectada à rede de água",
    gccm005_methodology_for_desalinated_water_savings_in_buildings:
      "GCCM005 - Metodologia para economia de água dessalinizada em edifícios",
    gccm006_energy_efficiency_measures_in_existing_centralized_cooling_systems:
      "GCCM006 - Medidas de eficiência energética em sistemas centralizados de resfriamento existentes",
    gccm007_methodology_for_private_carpooling_for_long_distance_inter_urban_travel:
      "GCCM007 - Metodologia para carona privada em viagens interurbanas de longa distância",
    gccma001_gcc_nbs_methodology_for_forestry_project_activities_on_lands_except_wetlands:
      "GCCMA001 - Metodologia GCC NBS para atividades florestais em terras, exceto áreas úmidas",
    gccma002_gcc_nbs_methodology_for_project_activities_on_degraded_mangrove_habitats:
      "GCCMA002 - Metodologia GCC NBS para atividades em habitats de manguezal degradados",
    gccma003_gcc_nbs_methodology_for_rewetting_drained_peatlands:
      "GCCMA003 - Metodologia GCC NBS para reumidificação de turfeiras drenadas",
    gccmt001_methodology_for_project_activities_involving_the_capture_transport_and_geological_storage_of_carbon_dioxide:
      "GCCMT001 - Metodologia para atividades com captura, transporte e armazenamento geológico de dióxido de carbono",
    geologically_stored_carbon: "Carbono armazenado geologicamente",
    improved_forest_management: "Manejo florestal melhorado",
    in_situ_capture_and_conversion_of_cattle_enteric_methane:
      "Captura e conversão in situ de metano entérico bovino",
    m001_terrestrial_forest_restoration:
      "M001 - Restauração de floresta terrestre",
    m002_terrestrial_forest_conservation:
      "M002 - Conservação de floresta terrestre",
    mangrove_restoration: "Restauração de manguezal",
    marine_anoxic_carbon_storage: "Armazenamento anóxico marinho de carbono",
    methane_emission_reduction_by_adjusted_water_management_practice_in_rice_cultivation:
      "Redução de emissões de metano por manejo ajustado da água no cultivo de arroz",
    methane_emissions_reduction_from_enteric_fermentation_in_beef_cattle_through_application_of_feed_supplements_under_revision:
      "Redução de emissões de metano da fermentação entérica em bovinos de corte por suplementos alimentares (em revisão)",
    methodology_for_animal_manure_management_and_biogas_use_for_thermal_energy_generation:
      "Metodologia para manejo de dejetos animais e uso de biogás para geração de energia térmica",
    methodology_for_collection_of_sargassum_and_other_macroalgae_to_avoid_emissions_from_decomposition_and_to_use_for_beneficial_products:
      "Metodologia para coleta de sargaço e outras macroalgas para evitar emissões de decomposição e uso em produtos benéficos",
    methodology_for_marine_fuels_and_biobunkers:
      "Metodologia para combustíveis marítimos e biobunkers",
    methodology_for_metered_measured_energy_cooking_devices:
      "Metodologia para fogões com energia medida e monitorada",
    methodology_for_reducing_methane_emissions_from_combustion_engine_exhaust:
      "Metodologia para redução de emissões de metano em escapamentos de motores a combustão",
    microalgae_carbon_fixation_and_sinking:
      "Fixação e afundamento de carbono por microalgas",
    microbial_carbon_di_oxide_mineralisation:
      "Mineralização microbiana de dióxido de carbono",
    ocean_alkalinity_enhancement_from_coastal_outfalls:
      "Aumento da alcalinidade oceânica a partir de emissários costeiros",
    open_system_ex_situ_mineralization:
      "Mineralização ex situ em sistema aberto",
    pm001_agriculture_forestry_carbon_benefit_assessment_methodology:
      "PM001 - Metodologia de avaliação de benefícios de carbono em agricultura e florestas",
    pm002_methodology_for_quantifying_carbon_benefits_from_small_scale_agroforestry:
      "PM002 - Metodologia para quantificar benefícios de carbono em agroflorestas de pequena escala",
    recovery_and_recycling_of_materials_from_solid_wastes:
      "Recuperação e reciclagem de materiais de resíduos sólidos",
    reduced_emissions_from_cooking_and_heating_technologies_and_practices_to_displace_decentralised_thermal_energy_consumption_tpddtec:
      "Reduções de emissões por tecnologias e práticas de cocção e aquecimento que substituem consumo térmico descentralizado (TPDDTEC)",
    reducing_methane_emissions_from_enteric_fermentation_in_dairy_cows_through_application_of_feed_supplements_under_revision:
      "Redução de emissões de metano da fermentação entérica em vacas leiteiras por suplementos alimentares (em revisão)",
    reduction_in_methane_emissions_from_landfills_through_decentralised_organic_waste_processing:
      "Redução de emissões de metano de aterros por processamento descentralizado de resíduos orgânicos",
    reforestation: "Reflorestamento",
    river_alkalinity_enhancement: "Aumento da alcalinidade de rios",
    scm0003_carbon_removal_in_private_conservation_areas:
      "SCM0003 - Remoção de carbono em áreas privadas de conservação",
    soil_organic_carbon_activity_module_biostimulants_for_soil_revitalisation:
      "Módulo de atividade de carbono orgânico do solo - bioestimulantes para revitalização do solo",
    soil_organic_carbon_activity_module_for_application_of_organic_soil_improvers_from_pulp_and_paper_mill_sludges:
      "Módulo de carbono orgânico do solo para aplicação de melhoradores orgânicos de lodos de celulose e papel",
    soil_organic_carbon_activity_module_for_cover_crops:
      "Módulo de carbono orgânico do solo para plantas de cobertura",
    soil_organic_carbon_activity_module_for_enhancing_carbon_stocks_in_managed_pasture:
      "Módulo de carbono orgânico do solo para aumentar estoques de carbono em pastagens manejadas",
    soil_organic_carbon_activity_module_for_zero_tillage:
      "Módulo de carbono orgânico do solo para plantio direto",
    soil_organic_carbon_activity_module_increasing_soil_carbon_through_improved_tillage_practices:
      "Módulo de carbono orgânico do solo: aumento de carbono por práticas melhoradas de preparo",
    soil_organic_carbon_framework_methodology:
      "Metodologia-base de carbono orgânico do solo",
    subsurface_biomass_carbon_removal_and_storage:
      "Remoção e armazenamento subterrâneo de carbono de biomassa",
    suppressed_demand_methodology_micro_scale_electrification_and_energization_under_revision:
      "Metodologia de demanda suprimida para eletrificação e energização em microescala (em revisão)",
    suppressed_demand_small_scale_methodology_for_energy_use_for_the_processing_of_agricultural_products_under_revision:
      "Metodologia de pequena escala de demanda suprimida para uso de energia no processamento de produtos agrícolas (em revisão)",
    suppressed_demand_small_scale_methodology_for_low_ghg_food_preservation_under_revision:
      "Metodologia de pequena escala de demanda suprimida para preservação de alimentos de baixo GEE (em revisão)",
    tero_001_redd: "TERO.001 - REDD+",
    tero_002_apd_avoided_planned_deforestation:
      "TERO.002 - APD (desmatamento planejado evitado)",
    tero_003_carbon_stock_in_forests:
      "TERO.003 - Estoque de carbono em florestas",
    tero_004_carbon_removal_in_agricultural_crops:
      "TERO.004 - Remoção de carbono em culturas agrícolas",
    tero_005_reduction_of_ghg_emissions_via_electric_vehicles:
      "TERO.005 - Redução de emissões de GEE por veículos elétricos",
    tero_006_arr_afforestation_reforestation_and_revegetation:
      "TERO.006 - ARR (florestamento, reflorestamento e revegetação)",
    tero_007_agricultural_land_management_alm:
      "TERO.007 - Manejo de terras agrícolas (ALM)",
    terrestrial_storage_of_biomass: "Armazenamento terrestre de biomassa",
    the_gold_standard_simplified_methodology_for_clean_and_efficient_cookstoves:
      "Metodologia simplificada Gold Standard para fogões limpos e eficientes",
    two_and_three_wheeled_personal_transportation:
      "Transporte pessoal de duas e três rodas",
    vm0001_refrigerant_leak_detection:
      "VM0001 - Detecção de vazamento de refrigerantes",
    vm0003_improved_forest_management_through_extension_of_rotation_age:
      "VM0003 - Manejo florestal melhorado por extensão da idade de rotação",
    vm0005_conversion_of_low_productive_forest_to_high_productive_forest:
      "VM0005 - Conversão de floresta de baixa produtividade em floresta de alta produtividade",
    vm0006_carbon_accounting_for_mosaic_and_landscape_scale_redd_projects:
      "VM0006 - Contabilidade de carbono para projetos REDD em mosaico e escala de paisagem",
    vm0007_redd_methodology_framework: "VM0007 - Marco metodológico REDD+",
    vm0008_weatherization_of_single_family_and_multi_family_buildings:
      "VM0008 - Eficiência térmica em edifícios unifamiliares e multifamiliares",
    vm0010_improved_forest_management_conversion_from_logged_to_protected_forest:
      "VM0010 - Manejo florestal melhorado: conversão de floresta explorada para protegida",
    vm0011_preventing_planned_degradation:
      "VM0011 - Prevenção de degradação planejada",
    vm0015_avoided_unplanned_deforestation:
      "VM0015 - Desmatamento não planejado evitado",
    vm0016_recovery_and_destruction_of_ozone_depleting_substances_ods_from_products:
      "VM0016 - Recuperação e destruição de substâncias que destroem o ozônio (ODS) de produtos",
    vm0018_energy_efficiency_and_solid_waste_diversion_activities_within_a_sustainable_community:
      "VM0018 - Eficiência energética e desvio de resíduos sólidos em comunidade sustentável",
    vm0019_fuel_switch_from_gasoline_to_ethanol_in_flex_fuel_vehicle_fleets:
      "VM0019 - Troca de gasolina por etanol em frotas flex-fuel",
    vm0025_campus_clean_energy_and_energy_efficiency:
      "VM0025 - Energia limpa e eficiência energética em campus",
    vm0032_adoption_of_sustainable_grasslands_through_adjustment_of_fire_and_grazing:
      "VM0032 - Adoção de pastagens sustentáveis por ajuste de fogo e pastejo",
    vm0033_tidal_wetland_and_seagrass_restoration:
      "VM0033 - Restauração de áreas úmidas de maré e ervas marinhas",
    vm0035_improved_forest_management_through_reduced_impact_logging:
      "VM0035 - Manejo florestal melhorado por exploração de impacto reduzido",
    vm0038_electric_vehicle_charging_systems:
      "VM0038 - Sistemas de recarga de veículos elétricos",
    vm0039_use_of_foam_stabilized_base_and_emulsion_asphalt_mixtures_in_pavement_application:
      "VM0039 - Uso de base estabilizada com espuma e misturas asfálticas em emulsão em pavimentos",
    vm0041_reduction_of_enteric_methane_emissions_from_ruminants_through_the_use_of_feed_ingredients:
      "VM0041 - Redução de metano entérico de ruminantes por ingredientes alimentares",
    vm0042_improved_agricultural_land_management:
      "VM0042 - Manejo agrícola melhorado",
    vm0043_co2_utilization_in_concrete_production:
      "VM0043 - Utilização de CO2 na produção de concreto",
    vm0044_biochar_utilization_in_soil_and_non_soil_applications:
      "VM0044 - Uso de biochar em aplicações no solo e fora do solo",
    vm0045_improved_forest_management_using_dynamic_matched_baselines_from_national_forest_inventories:
      "VM0045 - Manejo florestal melhorado com linhas de base dinâmicas pareadas de inventários nacionais",
    vm0046_reducing_food_loss_and_waste:
      "VM0046 - Redução de perdas e desperdício de alimentos",
    vm0047_afforestation_reforestation_and_revegetation:
      "VM0047 - Florestamento, reflorestamento e revegetação",
    vm0048_vmd0055_reducing_emissions_from_unplanned_deforestation:
      "VM0048/VMD0055 - Redução de emissões do desmatamento não planejado",
    vm0049_carbon_capture_and_storage:
      "VM0049 - Captura e armazenamento de carbono",
    vm0050_energy_efficiency_and_fuel_switch_measures_in_cookstoves:
      "VM0050 - Eficiência energética e troca de combustível em fogões",
    vm0051_improved_management_in_rice_production_systems:
      "VM0051 - Manejo melhorado em sistemas de produção de arroz",
    vm0052_accelerated_retirement_of_coal_fired_power_plants_using_a_just_transition:
      "VM0052 - Aposentadoria acelerada de usinas a carvão com transição justa",
    vmr0004_improved_efficiency_of_fleet_vehicles:
      "VMR0004 - Eficiência melhorada de veículos de frota",
    vmr0007_recovery_and_recycling_of_materials_from_solid_wastes:
      "VMR0007 - Recuperação e reciclagem de materiais de resíduos sólidos",
    vmr0008_recovery_and_recycling_of_materials_from_e_waste:
      "VMR0008 - Recuperação e reciclagem de materiais de lixo eletrônico",
    vmr0009_avoided_emissions_from_biomass_wastes_through_use_as_feedstock_in_pulp_and_paper_cardboard_fiberboard_or_bio_oil_production:
      "VMR0009 - Emissões evitadas de resíduos de biomassa usados como matéria-prima em celulose, papel, papelão, painéis ou bio-óleo",
    vmr0010_electricity_supply_for_ships:
      "VMR0010 - Fornecimento de eletricidade para navios",
    vmr0012_production_of_geopolymer_cement:
      "VMR0012 - Produção de cimento geopolimérico",
    vmr0013_lightweight_two_and_three_wheeled_personal_transportation:
      "VMR0013 - Transporte pessoal leve de duas e três rodas",
    vmr0014_electric_and_hybrid_vehicles_and_mobile_machinery:
      "VMR0014 - Veículos e máquinas móveis elétricos e híbridos",
    vmr0015_low_greenhouse_gas_emitting_safe_drinking_water_production_systems:
      "VMR0015 - Sistemas de produção de água potável segura com baixas emissões de GEE",
    vmr0016_flaring_or_use_of_landfill_gas:
      "VMR0016 - Queima ou uso de gás de aterro",
    wastewater_alkalinity_enhancement:
      "Aumento da alcalinidade de águas residuais",
  },
};
